import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VisitorStatisticExportComponent } from './component/visitor-statistic-export.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatSortModule } from '@angular/material/sort';
import { MatLegacyTableModule as MatTableModule } from '@angular/material/legacy-table';
import { ApplicationClientCommonModule, CommonTranslationModule, DictionaryModule } from '@sdbn/common';

@NgModule({
  imports: [
    CommonModule,
    DictionaryModule,
    MatTableModule,
    MatSortModule,
    ReactiveFormsModule,
    FormsModule,
    ApplicationClientCommonModule,
    CommonTranslationModule
  ],
  declarations: [VisitorStatisticExportComponent]
})
export class VisitorStatisticExportModule { }
